import { render, staticRenderFns } from "./Documenten.vue?vue&type=template&id=079674ca"
import script from "./Documenten.vue?vue&type=script&lang=js"
export * from "./Documenten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports